// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"bread-crumb_breadcrumb__1WG2i","talent_profile":"bread-crumb_talent_profile__NVg8s"};